import { useQuery } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { AiApi } from '@/Domain/api/AI/Ai.api';
import type { AIAssistantsData } from '@/Domain/components/TopBar/types';

export const useAiAssistant = () => {
  const { data, isLoading } = useQuery<AIAssistantsData>({
    queryKey: [Endpoint.ai.assistant],
    queryFn: () => AiApi.getAssistant(),
  });

  return { aiAssistant: data, isLoading };
};
